import React from 'react';

const SavedViews = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.5 12C12.8807 12 14 10.8807 14 9.5C14 8.11929 12.8807 7 11.5 7C10.1193 7 9 8.11929 9 9.5C9 10.8807 10.1193 12 11.5 12Z"
        fill="#787F88"
      />
      <path
        d="M11.5 20C15.6421 20 19 16.6421 19 12.5C19 8.35786 15.6421 5 11.5 5C7.35786 5 4 8.35786 4 12.5C4 16.6421 7.35786 20 11.5 20Z"
        stroke="#787F88"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8 18V15.5775C8 14.7324 8.95789 14 10.0632 14H12.9368C14.1158 14 15 14.7324 15 15.5775V18"
        stroke="#787F88"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default SavedViews;
